"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubstitutePhysicalOfficeAccessResponseSchema = exports.physicalOfficeAccessSiteGroupSchema = exports.physicalOfficeAccessOfficeSchema = void 0;
const zod_1 = require("zod");
exports.physicalOfficeAccessOfficeSchema = zod_1.z.object({
    doctorSubstituteId: zod_1.z.string().uuid(),
    siteId: zod_1.z.string().uuid(),
    siteName: zod_1.z.string(),
    officeId: zod_1.z.string().uuid(),
    officeName: zod_1.z.string(),
    officeAddressCity: zod_1.z.string(),
    granted: zod_1.z.boolean(),
    grantedAt: zod_1.z.string().datetime().nullable(),
});
exports.physicalOfficeAccessSiteGroupSchema = zod_1.z.object({
    siteId: zod_1.z.string().uuid(),
    siteName: zod_1.z.string(),
    offices: zod_1.z.array(exports.physicalOfficeAccessOfficeSchema),
    grantedCount: zod_1.z.number().int().nonnegative(),
    totalCount: zod_1.z.number().int().nonnegative(),
});
exports.getSubstitutePhysicalOfficeAccessResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        groups: zod_1.z.array(exports.physicalOfficeAccessSiteGroupSchema),
        grantedCount: zod_1.z.number().int().nonnegative(),
        totalCount: zod_1.z.number().int().nonnegative(),
    }),
});
